'use client';
import type { ProductDocument } from 'models/product';
import SafeImage from '@ui/SafeImage';
import { CurationsIcon } from '@c/icons';
import { SoldOutOverlay } from './SoldOutOverlay';
import { ProductAuctionCountdown } from './ProductAuctionCountdown';
import { ProductVariationImages } from './ProductVariationImages';
import { useState } from 'react';

export const ProductPicture = ({
  product,
  priority,
}: {
  product: ProductDocument;
  priority?: boolean;
}) => {
  const [activeImage, setActiveImage] = useState<string | undefined>(undefined);
  const endTime = product.end_time ?? 0;

  return (
    <div
      className={`relative h-[22rem] w-[22rem] overflow-hidden sm:h-[30rem] sm:w-full ${
        product.thumbnail.includes('wpsstatic') ||
        product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12'
          ? 'bg-zinc-50'
          : ''
      }`}
    >
      <SafeImage
        alt={product.title}
        src={activeImage ?? product.thumbnail}
        fallbackSrc={product.images[0]?.download_url}
        fill
        priority={priority}
        classes={`${
          product.thumbnail.includes('wpsstatic') ||
          product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12'
            ? 'object-contain'
            : 'object-cover'
        } h-full transition-all duration-100 ease-linear rounded-[3rem] group-hover:scale-[98%]`}
      />

      {product.from_recommend && (
        <div className="absolute  left-[1rem] top-[0.8rem] flex w-[4rem] gap-4 overflow-x-hidden whitespace-nowrap rounded-[0.4rem] bg-brand-secondary  px-4 py-[0.8rem]  font-semibold text-white transition-all hover:w-[10rem] ">
          <span className="grow">
            <CurationsIcon width={20} height={20} />
          </span>
          For you
        </div>
      )}

      {product.out_of_stock && !product.is_auction && <SoldOutOverlay />}

      {product.is_auction && endTime > Date.now() && !product.is_draft && (
        <ProductAuctionCountdown product={product} />
      )}

      <div className="z-5 absolute bottom-[0.8rem] left-[0.8rem] right-[0.8rem]">
        <ProductVariationImages
          product={product}
          activeImage={activeImage}
          onSelect={(img, e) => {
            e.preventDefault();
            e.stopPropagation();
            setActiveImage(img);
          }}
        />
      </div>
    </div>
  );
};
